import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IMenu } from '@/core/interfaces/admin/usestate-interfaces';
import { menuservice } from '@/projects/admin/services/menu-service';
import { applicationService } from '@/projects/admin/services/application-service';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import { useNavigate, useParams } from 'react-router-dom';

import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';
import { languageService } from '@/core/services/language-service';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';

function MenuDefinition(props: any) {
    const formRef: any = useRef<Form>();
    const [groupCaption, setGroupCaption] = useState(t('new_menu'));
    const params = useParams();
    const navigate = useNavigate();
    const [menuStore, setMenuStore] = useState<CustomStore | null>(null);
    const [featureStore, setFeatureStore] = useState<CustomStore | null>(null);
    const [languages, setLanguages] = useState([{ id: '', description: '', flagUrl: '', order: null, }]);
    const [menu, setMenu] = useState<IMenu>({
        id: '',
        applicationId: '',
        parentId: null,
        name: '',
        text: '',
        applicationFeatureId: null,
        order: 0,
        translates: []
    });
    const orderPattern = /^\d+$/;
    useEffect(() => {
        if (params && params.id !== undefined && menu && menu.id === '') {
            (async function () {
                setGroupCaption(t('edit_menu'));
                const menuResult = await menuservice.getMenuById(params.id)
                const data = menuResult.data;
                const menuTranslateResult = await menuservice.getMenuTranslate(data.id);
                const menuTranslateData = menuTranslateResult.data;
                setMenu({
                    id: data.id,
                    applicationId: data.applicationId,
                    parentId: data.parentId,
                    name: data.name,
                    text: data.text,
                    applicationFeatureId: data.applicationFeatureId,
                    order: data.order,
                    translates: menuTranslateData
                })
            })();
        }
    }, [menu]);

    const [applications] = useState(new CustomStore({
        key: 'id',
        load: applicationService.lookupApplication,
        byKey: async (key, loadOptions: any) => {
            var returnObject = null;
            if (key) {
                loadOptions.filter = ["id", "=", key];
                const objectsByID = (await applicationService.lookupApplication(loadOptions))
                returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
            }
            return returnObject
        },
        useDefaultSearch: true,
    }));


    const loadMenuStore = (applicationId:any)=>{
        setMenuStore(new CustomStore({
            key: 'id',
            load: menuservice.getAllMenu,
            byKey: async (key, loadOptions: any) => {
                var returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await menuservice.getAllMenu(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            onLoading(loadOptions) {
                if (applicationId) {
                  loadOptions.filter = ["ApplicationId", "=", applicationId]
                }
              },
            useDefaultSearch: true,
        }));
    }

    const loadFeatureStore = (applicationId:any)=>{
        setFeatureStore(new CustomStore({
            key: 'id',
            load: applicationService.getApplicationFeatures,
            byKey: async (key, loadOptions: any) => {
                var returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await applicationService.getApplicationFeatures(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            onLoading(loadOptions) {
                loadOptions.sort = [{"selector":"name","desc":false}] 
                if (applicationId) {
                  loadOptions.filter? loadOptions.filter.push(["ApplicationId", "=", applicationId]):loadOptions.filter =["ApplicationId", "=", applicationId]
                } 
              },
            useDefaultSearch: true,
        }));
    }



    useEffect(() => {
        const fetchLanguages = async () => {
            const languages = await languageService.getLanguages({});
            setLanguages(languages.data);
        };
        fetchLanguages();
    }, []);


    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const menuForm = formRef.current.props.formData;
                const elements = document.getElementsByClassName("languages");
                Array.from(elements).map((item, index) => {
                    const id = item.className.split(" ")[0];
                    menuForm.translates[index].languageId = id;
                });

                if (params && params.id) {
                    await menuservice.updateMenu(null, menuForm)
                } else {
                    await menuservice.createMenu(menuForm)
                }
                resolve();
                navigate('/admin/' + ROUTER_CONSTANTS.ADMIN.MenuList, {})
            } catch (error) {
                reject(error)
            }

        })
    }, []);


    const applicationEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'applicationId' },
        dataSource: applications,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
        onValueChanged: (e: any) => {
            if (e.value) {
                loadFeatureStore(e.value);
                loadMenuStore(e.value);
            }
        }
    };


    const parentMenuEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'parentMenuId' },
        dataSource: menuStore,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
    };

    
    const featureEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'id' },
        dataSource: featureStore,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
        searchEnabled: true
    };

    const pathEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'path' },
        dataSource: Object.entries(ROUTER_CONSTANTS).map(([key, value]) => ({ name: key, value: value })),
        displayExpr: 'name',
        valueExpr: 'value',
        placeholder: undefined,
    }
    return (
        <>
            <FormWrapper
                onSubmit={handleSubmit}
                formRef={formRef}
                formData={menu}
                backButtonNavigationPath={'/admin/' + ROUTER_CONSTANTS.ADMIN.MenuList}
                buttonGroups=
                {[
                    { buttonOptions: BUTTON_CONSTANTS.SaveBtn }]
                }
                simpleItemGroups={[
                    {
                        caption: groupCaption,
                        useColCountByScreen: true,
                        items: [
                            { dataField: 'name', label: 'menu_name', isRequired: true, },
                            { dataField: 'text', label: 'menu_text', isRequired: true, },
                            { dataField: 'order', label: 'menu_order', pattern: orderPattern, patternMessage: 'must_enter_integer' },
                            { dataField: 'applicationId', label: 'application', editorType: 'dxSelectBox', editorOptions: applicationEditorOptions, isRequired: true },
                            { dataField: 'parentId', label: 'parent_menu', editorType: 'dxSelectBox', editorOptions: parentMenuEditorOptions },

                            { dataField: 'applicationFeatureId', label: 'feature',editorType: 'dxSelectBox', editorOptions: featureEditorOptions },
                            ...languages.map((language, index) => ({
                                dataField: `translates[${index}].description`,
                                cssClass: `${language.id} languages`,
                                label: `${language.description} ${t('definition')}`,
                                isRequired: true,
                                requiredMessage: `${language.description} ${t('definition')} is required`
                            }))

                        ],
                    }
                ]}
            />
        </>


    )
};

export default MenuDefinition;